import { render } from "./my-edit-price.vue?vue&type=template&id=64e3c81c&scoped=true"
import script from "./my-edit-price.vue?vue&type=script&lang=js"
export * from "./my-edit-price.vue?vue&type=script&lang=js"

import "./my-edit-price.vue?vue&type=style&index=0&id=64e3c81c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e3c81c"]])

export default __exports__